<div class="auth-background">
  <app-card [disablePadding]="true">
    <div class="outer">
      <div id="hide-relation" class="container" [class.only-mobile]="!(showHeading || showHeading === null)">
        <div class="splash-header">
          <span id="app-name" class="hide-mobile">{{ appName }}</span>
          <span id="slogan" class="hide-mobile">{{ slogan }}</span>
          <img src="/logo-white.png" class="show-mobile" alt="logo">
        </div>
        <div class="splash-image hide-mobile">
          <img id="login-image" ngSrc="/login-image.png" width="470" height="311" alt="" priority>
        </div>
        <div class="splash-footer hide-mobile">
          <div class="dark-footer"></div>
        </div>
      </div>
      <div class="container full-width">
        @if ((showHeading || showHeading === null)) {
          <img ngSrc="/logo.png" class="logo" width="212" height="84" alt="">
        }

        <div class="wrapper">
          <div class="wrapper-inner">
            <router-outlet/>
          </div>

        </div>
      </div>
    </div>
  </app-card>
</div>
